module.exports = __webpack_public_path__ + "static/media/cabin-air-filters-mr-card-back.b714c45d.jpeg";